import React from 'react';
import { EmptyText } from 'library/ui';

export default function LocationStates({
    loading,
    empty,
    children,
}: {
    loading: boolean;
    empty: boolean;
    children: React.ReactNode;
}) {
    if (loading) {
        return <EmptyText padding="md">Loading...</EmptyText>;
    }

    if (empty) {
        return (
            <EmptyText padding="md">No locations found! Please contact support if you feel this is an error.</EmptyText>
        );
    }

    return <>{children}</>;
}
